import pigPriceApi from "@/api/pig-price/pigPriceApi";

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async fetchByCategory({dispatch}, cateogryId) {
      try {
        const response = await pigPriceApi.fetchByCategory(cateogryId);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async fetchCurrent({dispatch}, {categoryId, priceId}) {
      try {
        const response = await pigPriceApi.fetchCurrent(categoryId, priceId);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async fetchByDate({dispatch}, {categoryId, priceId, date}) {
      try {
        const response = await pigPriceApi.fetchByDate(categoryId, priceId, date);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async update({dispatch}, {form}) {
      try {
        const response = await pigPriceApi.update(form);
        dispatch('NOTIFY_MSG', 'pigPrice.notification.save', {root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async add({dispatch}, {form}) {
      try {
        const response = await pigPriceApi.add(form);
        dispatch('NOTIFY_MSG', 'pigPrice.notification.save', {root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async delete({dispatch}, {id}) {
      try {
        const response = await pigPriceApi.delete(id);
        dispatch('NOTIFY_MSG', 'pigPrice.notification.save', {root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async fillUp({dispatch}, {categoryId, till}) {
      try {
        const response = await pigPriceApi.fillUp(categoryId, till);
        dispatch('NOTIFY_MSG', 'pigPrice.notification.fillUp', {root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    }
  }
}
